import { render, staticRenderFns } from "./WarehouseCard.vue?vue&type=template&id=2e79bf0a&scoped=true"
import script from "./WarehouseCard.vue?vue&type=script&lang=js"
export * from "./WarehouseCard.vue?vue&type=script&lang=js"
import style0 from "./WarehouseCard.vue?vue&type=style&index=0&id=2e79bf0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79bf0a",
  null
  
)

export default component.exports